import React, { useState, useEffect, useContext } from 'react';
import { Table, Form, Input, message, Button, Select, Cascader, Tooltip } from 'antd';
import IconTip from '@/components/icon-tip';
import FilterBoxes from '@/components/filter-boxes';
import apis from '../apis';
import { filterConditions, formatPrice } from '@/common/utils';
import './index.less';
import ProviderUserTypeInfo from '../provider-userType-info';
import ModuleTitle from './module-title';
import TreeSelectDepartment, { validateSelectMax } from '@/form-component/tree-select-department';

export default function CommodityDetailsTable(props) {
  const value = useContext(ProviderUserTypeInfo);
  const { realTimeData = false, statisticsDimension = '0', platform, dt, planCode, startTime, endTime } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    total: 0,
    values: [],
  });
  const [brandAndShopList, setBrandAndShopList] = useState({
    brandList: [],
    shopList: [],
    cateTree: [],
  });
  const [form] = Form.useForm();
  const [conditions, setConditions] = useState({
    pageNum: 1,
    pageSize: 10,
    ...value,
  });

  useEffect(() => {
    setConditions((conditions) =>
      Object.assign({}, conditions, {
        realTimeData,
        statisticsDimension,
        platform,
        dt,
        planCode,
        pageNum: 1,
        startTime,
        endTime,
      })
    );
  }, [realTimeData, statisticsDimension, dt, planCode, platform, form, startTime, endTime]);

  const getColumns = () => {
    const columns = [
      {
        title: '商品信息',
        fixed: 'left',
        width: 230,
        render(record) {
          return (
            <div className="commodity-info-cell">
              <div className="commodity-info-cell-img">
                <img
                  src={
                    record.skuImageUrl ||
                    '//img30.360buyimg.com/pop/jfs/t1/184932/15/27050/1308/62d0d93fE6e5cf806/d8d8bec2d42087d3.png'
                  }
                  style={{ width: 40, height: 40 }}
                />
              </div>
              <div className="commodity-info-cell-desc">
                <Tooltip title={record.skuName}>
                  <div className="commodity-info-cell-desc-title">{record.skuName}</div>
                </Tooltip>
                <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.65)' }}>skuid：{record.skuId || '-'}</div>
              </div>
            </div>
          );
        },
      },
      {
        title: '活动名称',
        dataIndex: 'planName',
        width: 200,
        render(data) {
          return <span className="ellipsis-1-line">{data}</span>;
        },
      },
      {
        title: '日期',
        width: 180,
        render(record) {
          const { dt, hour, activityStartTime, activityEndTime } = record;
          // return dt + (hour ? ' ' + hour : '');
          if (!record.startTime) return dt;
          return (
            <>
              <div>{record.startTime + '~'}</div>
              <div>{record.endTime}</div>
            </>
          );
          // return statisticsDimension == '1' ? activityStartTime + '~' + activityEndTime : dt + (hour ? ' ' + hour : '');
        },
      },
      {
        title: '会场信息',
        width: 200,
        render(record) {
          return (
            <div>
              <Tooltip title={record.activityName}>
                <div className="ellipsis-1-line">{record.activityName}</div>
              </Tooltip>

              <div>编号：{record.activityId || '-'}</div>
            </div>
          );
        },
      },
      {
        title: '平台',
        width: 100,
        dataIndex: 'platform',
      },
      {
        title: '店铺',
        width: 150,
        dataIndex: 'shopName',
        render(data) {
          return (
            <Tooltip title={data}>
              <span className="ellipsis-1-line">{data}</span>
            </Tooltip>
          );
        },
      },
      {
        title: '一级品类',
        width: 120,
        dataIndex: 'cate1Name',
      },
      {
        title: '二级品类',
        width: 120,
        dataIndex: 'cate2Name',
      },
      {
        title: '三级品类',
        width: 120,
        dataIndex: 'cate3Name',
      },
      {
        title: '品牌',
        width: 120,
        render(record) {
          return (
            <div>
              <div className="ellipsis-1-line">{record.brandName}</div>
              <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.65)' }}>编号：{record.brandCode || '-'}</div>
            </div>
          );
        },
      },
      {
        title: (
          <>
            商品曝光PV
            <IconTip title="会场页面上商品曝光PV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'expPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品曝光UV
            <IconTip title="会场页面上商品曝光UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'expUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品点击PV
            <IconTip title="会场页面上商品点击PV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'clickPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            商品点击UV
            <IconTip title="会场页面上商品点击UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'clickUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引入商详PV
            <IconTip title="通过活动会场页面进入商详页面的PV（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'introSkuDetailPV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            引入商详UV
            <IconTip title="通过活动会场页面进入商详页面的UV去重（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
          </>
        ),
        width: 150,
        dataIndex: 'introSkuDetailUV',
        sorter: true,
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            直接引导成交订单金额
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单金额为直接引导成交订单金额" />
          </>
        ),
        width: 180,
        dataIndex: 'directiveIntroOrderValue',
        sorter: true,
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            直接引导成交订单量
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单量为直接引导成交订单量" />
          </>
        ),
        width: 160,
        sorter: true,
        dataIndex: 'directiveIntroParentOrderNum',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            直接引导成交UV
            <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生下单行为的用户数为直接引导成交UV" />
          </>
        ),
        width: 130,
        sorter: true,
        dataIndex: 'directiveIntroUV',
        render: (data) => {
          return formatPrice(data);
        },
      },
      {
        title: (
          <>
            UV点击率
            <IconTip title="商品点击UV/商品曝光UV" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'uvClickRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            UV成交率
            <IconTip title="直接引导成交UV/商品点击UV" />
          </>
        ),
        width: 120,
        sorter: true,
        dataIndex: 'uvDealRate',
        render: (data) => {
          return formatPrice(Number(data) * 100, '-', 1, '%');
        },
      },
      {
        title: (
          <>
            直接引导UV价值
            <IconTip title="直接引导成交订单金额/直接引导成交UV" />
          </>
        ),
        width: 160,
        sorter: true,
        dataIndex: 'directiveIntroUVValue',
        render: (data) => {
          return formatPrice(data);
        },
      },
    ];
    if (statisticsDimension == '1') {
      columns.splice(2, 1);
    }
    return columns;
  };

  useEffect(() => {
    if (!planCode) return;
    apis
      .queryBrandAndShopList({ ...value, planCode })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret != 0 || !data) throw msg || '品牌筛选出错';
        setBrandAndShopList(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [value, planCode]);

  useEffect(() => {
    if (!conditions.planCode) return;
    let didMount = true;
    setLoading(true);
    apis
      .getSkuDetailData(filterConditions(conditions))
      .then((res) => {
        if (!didMount) return;
        setLoading(false);
        const { ret, msg, data } = res;
        if (ret != 0 || !data) throw msg || '商品明细暂无数据';
        setData(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
    return () => {
      didMount = false;
    };
  }, [conditions]);

  const onFinish = (val) => {
    const { brandId, shopId, skuId, cate = [] } = val;
    let cate3Id = cate;

    setConditions((conditions) =>
      Object.assign({}, conditions, {
        planName: val.planName,
        pageNum: 1,
        brandId,
        shopId,
        skuId,
        cate3Id,
      })
    );
  };

  const downLoad = async (params) => {
    try {
      const res = await apis.getSkuDetailData(params);
      const { ret, msg, data } = res;
      if (ret != 0) throw msg || '导出数据失败';
      message.success('已开始导出数据，导出成功后将发到您的咚咚和邮箱，请注意查收！');
    } catch (ex) {
      message.error(ex);
    }
  };
  return (
    <div className="participant-detail-act-com-bg">
      <ModuleTitle title="商品明细表">
        <div className="commodity-detail-table-wrapper">
          <div className="commodity-detail-table-wrapper-filter">
            <FilterBoxes
              form={form}
              className="commodity-detail-table-wrapper-form"
              resetButtonProps={{
                onClick: () => {
                  form.resetFields();
                  form.submit();
                },
              }}
              onFinish={onFinish}
            >
              <Form.Item span={5} name="shopId" label="店铺">
                <Select
                  placeholder="请选择"
                  showSearch
                  allowClear
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {brandAndShopList.shopList.length &&
                    brandAndShopList.shopList.map((item) => {
                      return (
                        <Select.Option value={item.shopId} key={item.shopId}>
                          {item.shopName}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item span={5} name="cate" label="品类" rules={[{ validator: validateSelectMax }]}>
                <TreeSelectDepartment options={brandAndShopList.cateTree} />
              </Form.Item>
              <Form.Item span={4} name="brandId" label="品牌">
                <Select
                  placeholder="请选择"
                  showSearch
                  allowClear
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {brandAndShopList.brandList.length &&
                    brandAndShopList.brandList.map((item) => {
                      return (
                        <Select.Option value={item.brandCode} key={item.brandCode}>
                          {item.brandName}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item span={5} name="skuId" label="SKU ID">
                <Input placeholder="请输入SKU ID" allowClear />
              </Form.Item>
            </FilterBoxes>
            <div className="down-load-data">
              <Button type="primary" onClick={() => downLoad({ downLoad: true, ...value, ...conditions })}>
                导出数据
              </Button>
            </div>
          </div>
          <Table
            style={{ marginTop: 16 }}
            columns={getColumns()}
            dataSource={data.values}
            scroll={{ x: 3050 }}
            loading={loading}
            pagination={{
              total: data.total,
              current: conditions.pageNum,
              pageSize: conditions.pageSize,
              // pageSizeOptions: [10, 20, 50, 100],
              // showSizeChanger: true,
              showQuickJumper: true,
            }}
            onChange={(pagination, filters, sorter, { action }) => {
              let _val = {};
              if (action == 'sort') {
                _val = {
                  orderBy: sorter.order && sorter.field,
                  sequence: sorter.order?.replace('end', ''),
                  pageNum: 1,
                };
              }
              if (action == 'paginate') {
                _val = { pageNum: pagination.current };
              }
              setConditions((conditions) => Object.assign({}, conditions, _val));
            }}
          />
        </div>
      </ModuleTitle>
    </div>
  );
}
